import React from "react";
import { Button } from "antd";

function Terms(props) {
  const { setShowTermsDrawer } = props;

  return (
    <div className="wrap-terms">
      <p className="terms-content">
        صرف ورود کاربر به نرم افزار و یا سامانه و اقدام به استفاده از خدمات
        .لاوین به منزله پذیرش قطعی شرایط .و مقررات ذیل و تغییرات آتی آن خواهد
        بود
        <br />
        <br />
        وکلای فعال در سامانه از وکلای رسمی دادگستری بوده و این وکلا صلاحیت ارائه
        خدمات حقوقی را داشته و شخصاً پاسخگوی کیفیت خدمات ارائه شده هستند
        <br />
        صرفاً هر گونه تقاضا یا ارسال پیام یا مدارک را از طریق اپ انجام داده و از
        هرگونه ارتباط با وکیل خارج از محیط اپ خودداری خواهم نمود
        <br />
        راهنمای بهای خدمات را مطالعه نموده و کلیه شرایط
        <br />
        آن را می پذیرم
        <br />
        از ارسال هر گونه پیام یا اقدام خارج از موضوع خدمات حقوقی در محیط اپ
        خودداری خواهم نمود
        <br />
        راهنمای ارائه خدمات حقوقی به وسیله وکلا را مطالعه کرده و شرایط آن را می
        پذیرم.
        <br />
      </p>

      <Button
        type="primary"
        // icon={<ArrowRightOutlined />}
        onClick={() => setShowTermsDrawer()}
        // disabled={loading}
      >
        بستن
      </Button>
    </div>
  );
}

export default Terms;
